// The period-type contract shared by the control that offers these values and the code that
// switches on them. SearchSelectionBox used to hardcode the option values while PeriodFilter
// hardcoded the matching `case` labels, so the two agreed only by coincidence and nothing failed
// at build time if one changed. Both now read this module, as does the store seeding the initial
// filter.
// @since NEXT_VERSION

// A whole calendar month, chosen with the Year + Select Month pair.
// @since NEXT_VERSION
export const PERIOD_OPTION_MONTH = "MONTH";
// A fiscal week number within a year.
// @since NEXT_VERSION
export const PERIOD_OPTION_FISCAL_WEEK = "FISCAL_WEEK";
// An explicit start and end date, which is why no Year accompanies it.
// @since NEXT_VERSION
export const PERIOD_OPTION_CUSTOM_DATES = "CUSTOM_DATES";

/**
 * The dropdown's own options, in the order they are offered. Exported as the list rather than
 * assembled at the call site so the values and their labels cannot drift apart between screens.
 * @since NEXT_VERSION
 */
export const PERIOD_OPTIONS = [
  { value: PERIOD_OPTION_MONTH, label: "Month" },
  { value: PERIOD_OPTION_CUSTOM_DATES, label: "Custom Dates" },
  { value: PERIOD_OPTION_FISCAL_WEEK, label: "Fiscal Week" },
];
